// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--mSk4s","feature":"_93444fe79c--feature--lXT79"};